/* src/app/_shared/components/sticky-content/sticky-content.component.scss */
:host {
  display: block;
  position: relative;
  top: 0;
  z-index: 999;
  width: 100%;
  --padding: var(--space-top) var(--space-right) var(--space-bottom) var(--space-left);
}
.flow-sticky-content {
  padding: var(--padding);
  background-color: #FFFFFF;
}
/*# sourceMappingURL=sticky-content.component.css.map */
